var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',_vm._b({attrs:{"value":_vm.value},on:{"input":function (val) { return _vm.$emit('input', val); }}},'b-form-input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }